/**
 * API Client
 * Centralized axios instance for API calls
 */

import axios from 'axios';
import { getToken } from '../utils/tokenStorage';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // 60 seconds - increased for AI operations like report generation
  withCredentials: true // Send httpOnly auth cookie on every request
  // No default Content-Type: axios sets application/json for objects and lets the
  // browser set multipart/form-data (with boundary) for FormData uploads.
});

// Request interceptor: attach Bearer token when available.
// On web the cookie also goes (withCredentials), so both auth mechanisms are sent.
// On native (Capacitor) the Bearer token is the primary auth mechanism.
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't auto-logout on 401 - let components handle it
    // This prevents logout loops during initialization

    // Tag pending-approval 403s so callers can distinguish them from other
    // permission errors without treating them as session failures.
    if (error.response?.status === 403 && error.response?.data?.code === 'ACCOUNT_PENDING_APPROVAL') {
      error.isPendingApproval = true;
    }

    return Promise.reject(error);
  }
);

export default api;

